import axios from 'axios';
import env from '../config/env';
import { sendFile } from './fileSender';
const ROOT_URL = env.backendUrlPrefix;

export function gettingUserDetails(urlUserDetails, jwtToken) {
  return axios({
    method: 'get',
    url: `${ROOT_URL}${urlUserDetails}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${jwtToken}`
    }
  });
}

export function getttingDealInfo(id, jwtToken) {
  return axios({
    method: 'get',
    url: `${ROOT_URL}/contracts/member/${id}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${jwtToken}`
    }
  });
}

export function getttingDealInfoVirtual(id, jwtToken) {
  return axios({
    method: 'get',
    url: `${ROOT_URL}/contracts/virtual/member/${id}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${jwtToken}`
    }
  });
}

// fetch banks

export function fetchBanksAndBranch(jwtToken) {
  return axios({
    method: 'get',
    url: `${ROOT_URL}/banks`,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${jwtToken}`
    }
  });
}

// Fetching branches
export function fetchBranches(branch, jwtToken) {
  return axios({
    method: 'get',
    url: `${ROOT_URL}/banks/${branch}/branches`,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${jwtToken}`
    }
  });
}

export function updateUserDetails(userData, jwtToken) {
  return axios({
    method: 'put',
    url: `${ROOT_URL}/members`,
    data: userData,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${jwtToken}`
    }
  });
}

export function fetchUserContracts(userId, jwtToken) {
  const urlContracts = `${ROOT_URL}/contracts/members/${userId}/signatureRequests`;
  return axios({
    method: 'post',
    url: urlContracts,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${jwtToken}`
    }
  }).then(response => ({
    contracts: response.data
  }));
}

export function getNewContractUrl(memberId, signatureId, jwtToken) {
  return axios({
    method: 'get',
    url: `${ROOT_URL}/contracts/members/${memberId}/signatureRequests/${signatureId}/url`,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${jwtToken}`
    }
  }).then(response => response.data.contractURL);
}

export function getContractPdfUrl(signatureRequestId, token) {
  return axios({
    method: 'get',
    url: `${ROOT_URL}/contracts/signatureRequests/${signatureRequestId}/download/url/`,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${token}`
    }
  }).then(response => response.data);
}

export function sendingIdPhoto(memberId, photoFile, jwtToken) {
  if (!photoFile) {
    return Promise.reject('no file was given');
  }
  const sizeInMB = photoFile.size / 1000000;
  if (sizeInMB > 5) {
    return Promise.reject('file-too-big');
  }
  return sendFile({
    file: photoFile,
    url: `${ROOT_URL}/contracts/members/${memberId}/idPhoto/upload`,
    headers: [{ key: 'Authorization', value: `bearer ${jwtToken}` }]
  });
}

export function sendSignedAll(id, jwtToken) {
  return axios({
    method: 'post',
    url: `${ROOT_URL}/contracts/members/${id}/signedAll`,
    headers: {
      'Content-Type': 'multipart/form-data',
      authorization: `bearer ${jwtToken}`
    }
  }).then(response => response.data);
}

const periods = {
  'Half year': 'HALF_YEAR',
  Yearly: 'YEARLY',
  Monthly: 'MONTHLY'
};
// Virtual Members
export function sendVirtualMember(plan, userData, period) {
  return axios({
    method: 'post',
    url: `${ROOT_URL}/vennp/members/neighbour?membershipPlan=${plan}&planPeriod=${periods[period]}`,
    data: userData,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer public`
    }
  });
}

export function sendAppLinkBySms(id, jwtToken) {
  return axios({
    method: 'post',
    url: `${ROOT_URL}/contracts/members/${id}/sendAppLink`,
    headers: {
      'Content-Type': 'multipart/form-data',
      authorization: `bearer ${jwtToken}`
    }
  }).then(response => response.data);
}

// payment

export function sendBillRegistration(token, encryptedCvv, jwtToken) {
  return axios({
    method: 'post',
    url: `${ROOT_URL}/payments/bill/membership`,
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${jwtToken}`
    },
    data: {
      token,
      encrypted_cvv: encryptedCvv
    }
  }).then(response => response.data);
}



// WEBPACK FOOTER //
// ./src/services/backendService.js